import RegisterRouter from "./router/user-register-router";

export default [RegisterRouter];